// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5608) return "static/chunks/5608-7feca5847aff70ad.js";
	if (chunkId === 9334) return "static/chunks/9334-3f20346fced2ee02.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5604 ? "7cb1fa1f" : chunkId) + "." + {"1514":"56405a0190947d19","1646":"314724838722bc18","2399":"bc041234521f0282","5139":"3af505ae0c727fe9","5267":"85ca86995d7be499","5604":"ddc99621ba33e04a","5828":"86e3ca0f1bd89d2b","8765":"0123e200695f05e2"}[chunkId] + ".js";
};